// extracted by mini-css-extract-plugin
module.exports = {"tags":"tagsseo_tags__AsA5Q","rowWrap":"tagsseo_rowWrap__JK0HH"};